import { useEffect, useState } from "react";
import { useAppDispatch } from "../store";
import {
  setModuleUrls,
  setSiteData,
  setWebsiteMenu,
} from "../slice/siteDataSlice";
import { appAxios } from "../axios/axios";
import { setUserData, setUserDataLoading } from "../slice/userDataSlice";
import { getAuthToken } from "../commonGlobals/functions/localStorage/getUser";
import axios from "axios";
import {
  TopMenuEnum,
  moduleIcons,
} from "../components/Common/WidgetMenuHelper";
import { ModuleUrls } from "../interfaces/websiteData.interface";

export const useInitiateApp = () => {
  const dispatch = useAppDispatch();
  const [loadingData, setLoadingData] = useState(false);

  const setReduxMenu = (siteData) => {
    const menuArr = siteData?.activeModules
      ?.filter((am) => {
        if (
          am.siteModule.module_name === "TourPackageForm" ||
          am.siteModule.module_name === TopMenuEnum.activities
        ) {
          return false;
        }
        return am.is_active;
      })
      .map((am, index) => {
        let moduleName = am.siteModule.module_name;
        let moduleLink = moduleName;
        let key = moduleName;
        let moduleIcon = moduleIcons.filter(
          (iconObj) => iconObj.title === moduleName
        )[0]?.icon;

        if (moduleName === TopMenuEnum.flightsForm) {
          moduleName = "FlightEnquiry";
        }
        if (moduleName === TopMenuEnum.prePurchased) {
          moduleName = "FlightDeals";
        }
        moduleName = moduleName.replace(/([A-Z])/g, " $1").trim();
        let type = moduleName;

        if (type === "Hotels") {
          type = "Hotel Enquiry";
        }
        const changeType = ["Bus", "Cruise", "Train", "Insurance"];
        if (changeType.includes(type)) {
          type = type + " Enquiry";
        }

        return {
          key,
          moduleName,
          moduleIcon,
          moduleLink,
          type,
        };
      });
    dispatch(setWebsiteMenu(menuArr));
  };

  const setCssVariables = (primary, secondary) => {
    const root = document.documentElement;

    if (primary) {
      root?.style.setProperty("--primary", primary);
    }
    if (secondary) {
      root?.style.setProperty("--secondary", secondary);
    }
  };

  function createDomElem<K extends keyof HTMLElementTagNameMap>(
    tagName: K,
    attributes: Partial<HTMLElementTagNameMap[K]>
  ) {
    const elem = document.createElement(tagName);

    Object.entries(attributes).forEach(([key, value]) => {
      elem.setAttribute(key, value);
    });

    if (tagName === "link") {
      document.head.appendChild(elem);
    } else {
      document.body.appendChild(elem);
    }
  }

  const createHeaderFooterLinks = (
    ssrElements: {
      header: string;
      footer: string;
    },
    scriptUrls?: string[]
  ) => {
    let headerType = "header_V1";
    let footerType = "footer_V1";

    if (ssrElements?.header && ssrElements?.footer) {
      headerType = ssrElements.header;
      footerType = ssrElements.footer;
    }
    let baseUrl = "";

    if (process.env.NODE_ENV === "development") {
      baseUrl = "http://localhost:5000";
    }

    createDomElem("script", {
      src: `https://ajax.googleapis.com/ajax/libs/jquery/2.1.1/jquery.min.js`,
      type: "text/javascript",
    });

    createDomElem("link", {
      rel: "stylesheet",
      href: `${baseUrl}/api/assets/css/ejsHeaderFooter/header/${headerType}.css`,
    });

    createDomElem("link", {
      rel: "stylesheet",
      href: `${baseUrl}/api/assets/css/ejsHeaderFooter/footer/${footerType}.css`,
    });

    scriptUrls?.forEach((scriptUrl) => {
      createDomElem("script", {
        src: scriptUrl,
        type: "text/javascript",
      });
    });
  };

  const getSiteData = async () => {
    setLoadingData(true);
    let domain = window.location.hostname;
    if (domain === "localhost" || domain === "192.168.0.109") {
      domain = "1.landarrangement.com";
    }

    await appAxios
      .post("/api/detect", {
        domain,
      })
      .then((res) => {
        const { moduleUrls, userData, scriptUrls, ...siteData } =
          res.data.result;
        setCssVariables(
          siteData?.brandingSettings?.form?.theme?.palette?.primary?.main,
          siteData?.brandingSettings?.form?.theme?.palette?.secondary?.main
        );

        let ssrElements = siteData?.brandingSettings?.ssrElements;
        createHeaderFooterLinks(ssrElements, scriptUrls);

        setReduxMenu(siteData);
        dispatch(setSiteData(siteData));
        dispatch(setModuleUrls(moduleUrls));
        dispatch(setUserData(userData));

        // const siteData = res.data.result;
        // setCssVariables(
        //   siteData?.brandingSettings?.form?.theme?.palette?.primary?.main,
        //   siteData?.brandingSettings?.form?.theme?.palette?.secondary?.main
        // );
        // let ssrElements = siteData?.brandingSettings?.ssrElements;
        // createHeaderFooterLinks(ssrElements, siteData.scriptUrls);

        // dispatch(setSiteData(siteData));
      })
      .catch((err) => {
        console.log(err);
        if (err.response?.status === 401) {
          const moduleUrls: ModuleUrls = err.response.data.moduleUrls;
          dispatch(setSiteData(null));
          dispatch(setModuleUrls(moduleUrls));
          dispatch(setUserData(undefined));
          window.location.href = moduleUrls.logout || "/app/logout";
        }
      })
      .finally(() => {
        setLoadingData(false);
      });
  };

  const getUserData = async () => {
    const token = getAuthToken();
    if (token) {
      dispatch(setUserDataLoading(true));
      await appAxios
        .post(
          "/api/getUserBySessionId",
          {},
          {
            headers: {
              "auth-token": token,
            },
          }
        )
        .then((res) => {
          dispatch(setUserData(res.data.result));
        })
        .catch((err) => {
          // IF ERROR OCCUR LOGOUT THE USER WHICH IS DONE FROM USEAPPAXIOS HOOK
        });
      dispatch(setUserDataLoading(false));
    } else {
      // reseting the redux if any old user data is present
      dispatch(setUserData(undefined));
    }
  };

  // const getModuleUrls = async () => {
  //   try {
  //     const moduleUrlsResponse = await appAxios.get("/api/getModuleUrls");
  //     const moduleUrl = moduleUrlsResponse.data.result;

  //     if (moduleUrlsResponse.data.success) {
  //       dispatch(setModuleUrls(moduleUrl));
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const initApp = async () => {
    await getSiteData();
    // await getModuleUrls();
    // await getUserData();
  };

  useEffect(() => {
    initApp();
  }, [dispatch]);

  return loadingData;
};
